module.exports = __webpack_public_path__ + "media/images/logo_enel-633a23e7a2f489fd7391eaffb3efabef.png";